import { CollapsibleBox, MutedBox, PostSectionTitle } from './post-section-components';

import type { Post } from '@/entities/post/post-types';

export const VideoSummary = ({ post }: { post: Post }) => {
  const isVideoSummaryEmpty = !post.analyzation?.video_summary;
  if (isVideoSummaryEmpty) return null;
  return (
    <MutedBox className="flex flex-col">
      <CollapsibleBox trigger={<PostSectionTitle>Video summary</PostSectionTitle>} initialOpen>
        <div className="flex flex-col gap-6">
          {!isVideoSummaryEmpty && (
            <div className="text-muted-foreground min-w-0 pt-6 text-base font-medium wrap-break-word break-keep">
              {post.analyzation?.video_summary}
            </div>
          )}
        </div>
      </CollapsibleBox>
    </MutedBox>
  );
};
